import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  MaterializedPage,
  MaterializedPageSearch,
  SearchMaterializedPagesResponse,
  getMaterializedPage as universalGetMaterializedPage,
  searchMaterializedPages as universalSearchMaterializedPages,
} from './quickpages-materializedpages-v1-materialized-page-materialized-pages.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/quick-pages' };

/** @internal */
export function getMaterializedPage(
  httpClient: HttpClient
): GetMaterializedPageSignature {
  return (materializedPageId: string) =>
    universalGetMaterializedPage(
      materializedPageId,
      // @ts-ignore
      { httpClient }
    );
}

interface GetMaterializedPageSignature {
  /**
   * Retrieves a MaterializedPage.
   * @param - ID of the MaterializedPage to retrieve.
   * @returns The requested MaterializedPage.
   */
  (materializedPageId: string): Promise<
    NonNullablePaths<
      MaterializedPage,
      | `status`
      | `searchEngineIndexingEnabled`
      | `tags.privateTags.tagIds`
      | `publicationDetails.publishedPageId`
      | `publicationDetails.contentId`
      | `publicationDetails.slug`
      | `contentDetails.latestContentId`
      | `pageRoute.slug`
      | `pageRoute.urlType`,
      4
    >
  >;
}

/** @internal */
export function searchMaterializedPages(
  httpClient: HttpClient
): SearchMaterializedPagesSignature {
  return (search: MaterializedPageSearch) =>
    universalSearchMaterializedPages(
      search,
      // @ts-ignore
      { httpClient }
    );
}

interface SearchMaterializedPagesSignature {
  /**
   * Retrieves a list of up to 100 materialized pages, given the specified filtering, search expression, sorting, and cursor paging ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/api/rest/getting-started/api-query-language)).
   * @param - WQL expression.
   */
  (search: MaterializedPageSearch): Promise<
    NonNullablePaths<
      SearchMaterializedPagesResponse,
      | `materializedPages`
      | `materializedPages.${number}.status`
      | `materializedPages.${number}.searchEngineIndexingEnabled`
      | `materializedPages.${number}.publicationDetails.publishedPageId`
      | `materializedPages.${number}.publicationDetails.contentId`
      | `materializedPages.${number}.publicationDetails.slug`
      | `materializedPages.${number}.contentDetails.latestContentId`
      | `materializedPages.${number}.pageRoute.slug`
      | `materializedPages.${number}.pageRoute.urlType`
      | `aggregationData.results`
      | `aggregationData.results.${number}.scalar.type`
      | `aggregationData.results.${number}.scalar.value`
      | `aggregationData.results.${number}.name`
      | `aggregationData.results.${number}.type`
      | `aggregationData.results.${number}.fieldPath`,
      6
    >
  >;
}

export {
  AccountInfo,
  ActionEvent,
  Aggregation,
  AggregationData,
  AggregationKindOneOf,
  AggregationResults,
  AggregationResultsResultOneOf,
  AggregationResultsScalarResult,
  AggregationType,
  ContentDetails,
  CursorPaging,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Cursors,
  DateHistogramAggregation,
  DateHistogramResult,
  DateHistogramResults,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  ExtendedFields,
  GetMaterializedPageRequest,
  GetMaterializedPageResponse,
  GroupByValueResults,
  IdentificationData,
  IdentificationDataIdOneOf,
  IncludeMissingValuesOptions,
  Interval,
  MaterializedPage,
  MaterializedPageSearchSpec,
  MessageEnvelope,
  MissingValues,
  Mode,
  NestedAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  NestedAggregationType,
  NestedResultValue,
  NestedResultValueResultOneOf,
  NestedResults,
  NestedValueAggregationResult,
  PageRoute,
  PagingMetadataV2,
  PublicationDetails,
  RangeAggregation,
  RangeAggregationResult,
  RangeBucket,
  RangeResult,
  RangeResults,
  RestoreInfo,
  Results,
  ScalarAggregation,
  ScalarResult,
  ScalarType,
  SearchDetails,
  SearchMaterializedPagesRequest,
  SearchMaterializedPagesResponse,
  SortDirection,
  SortOrder,
  SortType,
  Sorting,
  Status,
  TagList,
  Tags,
  Type,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  ValueAggregationResult,
  ValueResult,
  ValueResults,
  WebhookIdentityType,
  utils,
} from './quickpages-materializedpages-v1-materialized-page-materialized-pages.universal.js';
